import { IMAGES } from './constants';

const normalizeImageSrc = (value = '') => {
  if (!value || typeof value !== 'string') return '';
  if (value.startsWith('//')) return `https:${value}`;
  return value;
};

const getImageDedupeKey = (imageSrc = '') => {
  const normalizedSrc = normalizeImageSrc(imageSrc);
  if (!normalizedSrc) return '';

  try {
    const url = new URL(normalizedSrc, window.location.origin);
    return `${url.origin}${url.pathname}`;
  } catch (error) {
    return normalizedSrc.split('?')[0];
  }
};

const getSizedImageSrc = (imageSrc = '', width = IMAGES.DEFAULT_WIDTH) => {
  const normalizedSrc = normalizeImageSrc(imageSrc);
  if (!normalizedSrc) return '';

  try {
    const url = new URL(normalizedSrc, window.location.origin);
    if (!url.hostname.includes(IMAGES.SHOPIFY_CDN_HOST)) return normalizedSrc;

    url.searchParams.set('width', String(width));
    return url.toString();
  } catch (error) {
    return normalizedSrc;
  }
};

const getUniqueImages = (images = []) => {
  const seen = new Set();

  return images
    .map(normalizeImageSrc)
    .filter(Boolean)
    .filter((imageSrc) => {
      const dedupeKey = getImageDedupeKey(imageSrc);
      if (!dedupeKey || seen.has(dedupeKey)) return false;
      seen.add(dedupeKey);
      return true;
    });
};

export { normalizeImageSrc, getImageDedupeKey, getSizedImageSrc, getUniqueImages };
